/**
 * iurop-cart-drawer.js — Sidecart dinámico (Gudslip, base IUROP)
 *
 * - Mutaciones de carrito DENTRO del drawer (cantidad +/- y eliminar) vía
 *   /cart/change.js con Section Rendering → re-pinta el drawer en 1 ida.
 * - Adiciones EXTERNAS (PDP, cards, upsells) van por el quick-add global de
 *   header.js, que tras añadir dispara `cart:updated` → aquí refrescamos el
 *   drawer (Section Rendering por GET) y lo ABRIMOS.
 * - Temporizador de reserva: arranca al tener ítems, persiste en localStorage,
 *   se reinicia si vacías el carrito y lo empiezas de nuevo, y cambia el copy
 *   al llegar a 0. Minutos y textos son editables (settings → Liquid).
 * - Modal Klarna (mismo contenido que la PDP), scoped al drawer.
 *
 * El abrir/cerrar base lo gestiona global.js por atributos:
 *   [data-open] en [data-cart-drawer] + [data-drawer-open] en <html>.
 */
(function () {
  'use strict';

  var RESERVE_KEY = 'iurop:cart-reserve-start';
  var reserveTimer = null;
  var busy = false;

  // --- Rutas de carrito LOCALIZADAS -----------------------------------------
  // gudslip.com es multi-mercado con prefijo en la URL (/es-es = EUR, raíz = USD).
  // Llamar a "/cart.js" a pelo desde /es-es habla con el carrito del mercado RAÍZ
  // → importes y divisa mezclados en el drawer. `window.routes` lo emite
  // layout/theme.liquid ya localizado ("/es-es/cart/add"...).
  function route(key, fallback) {
    return (window.routes && window.routes[key]) || fallback;
  }
  function cartJson() { return route('cart_url', '/cart') + '.js'; }
  function cartUpdateJson() { return route('cart_update_url', '/cart/update') + '.js'; }
  function cartAddJson() { return route('cart_add_url', '/cart/add') + '.js'; }

  function drawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  // --- Multidivisa de los hitos (QA 2026-08-14, SC7) ------------------------
  // Los umbrales se configuran en EUROS (divisa de tienda) y Liquid los compara
  // contra cart.total_price, que viene en la divisa del MERCADO. En un mercado
  // en dólares "50 €" se comparaba como 50 $ y no cuadraban ni la barra, ni el
  // "te faltan X", ni el auto-añadido de regalos. Aquí se reconvierte en cliente.
  // Con rate 1 (mercado en la divisa de tienda) se sale antes de tocar nada.
  function currencyRate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c && parseFloat(c.rate);
    return r && isFinite(r) && r > 0 ? r : 1;
  }
  function toPresentment(shopCents) {
    return Math.round(shopCents * currencyRate());
  }
  function formatMoney(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = document.documentElement.lang || 'es';
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function syncCurrency(cartTotal) {
    if (currencyRate() === 1) return; // mercado en divisa de tienda: nada que convertir
    var el = drawer();
    var prog = el && el.querySelector('[data-cd-progress]');
    if (!prog) return;

    var total = typeof cartTotal === 'number'
      ? cartTotal
      : parseInt(prog.getAttribute('data-cart-total'), 10) || 0;

    var hitos = Array.prototype.slice.call(prog.querySelectorAll('[data-hito-amount]'))
      .map(function (b) {
        var wrap = b.closest('.gudslip-cd__hito');
        return {
          b: b,
          shop: parseInt(b.getAttribute('data-hito-amount'), 10) || 0,
          pos: wrap ? parseFloat(wrap.style.left) || 0 : 0
        };
      })
      .filter(function (h) { return h.shop > 0; });
    if (!hitos.length) return;

    // Importes de cada hito, ya convertidos
    hitos.forEach(function (h) { h.b.textContent = formatMoney(toPresentment(h.shop)); });

    // Relleno segmentado (mismo criterio que Liquid: llega a cada icono al completarlo)
    var last = hitos[hitos.length - 1];
    var fill;
    if (total >= toPresentment(last.shop)) {
      fill = last.pos;
      hitos.forEach(function (h) {
        var w = h.b.closest('.gudslip-cd__hito');
        if (w) w.classList.toggle('is-reached', total >= toPresentment(h.shop));
      });
    } else {
      var prevPos = 0, prevVal = 0;
      for (var i = 0; i < hitos.length; i++) {
        var t = toPresentment(hitos[i].shop);
        var w = hitos[i].b.closest('.gudslip-cd__hito');
        if (w) w.classList.toggle('is-reached', total >= t);
        if (fill === undefined && total < t) {
          fill = prevPos + ((hitos[i].pos - prevPos) * (total - prevVal)) / Math.max(1, t - prevVal);
        }
        prevPos = hitos[i].pos; prevVal = t;
      }
    }
    var bar = prog.querySelector('.gudslip-cd__bar-fill');
    if (bar && typeof fill === 'number') bar.style.width = Math.max(0, Math.min(100, fill)) + '%';

    // Texto "te faltan X"
    var texto = prog.querySelector('.gudslip-cd__progress-text');
    var siguiente = null;
    for (var j = 0; j < hitos.length; j++) {
      if (total < toPresentment(hitos[j].shop)) { siguiente = hitos[j]; break; }
    }
    if (texto && siguiente) {
      var tpl = total < toPresentment(hitos[0].shop)
        ? prog.getAttribute('data-tpl-missing')
        : prog.getAttribute('data-tpl-next');
      if (tpl) texto.innerHTML = tpl.replace('__AMT__', formatMoney(toPresentment(siguiente.shop) - total));
    }
  }

  // --- Contadores de carrito (drawer + header) -----------------------------
  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-hidden', n === 0);
    });
  }

  // --- Abrir / cerrar (mismo contrato que global.js) -----------------------
  function openDrawer() {
    var el = drawer();
    if (!el) return;
    el.setAttribute('data-open', 'true');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }

  // --- Temporizador de reserva ---------------------------------------------
  function fmt(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  // QA 2026-08-14 (SC2): el temporizador solo arrancaba de cero cuando el
  // carrito se vaciaba; al añadir otro producto seguía corriendo el de antes.
  // Se guarda el nº de unidades del último pintado: si sube, la reserva vuelve
  // a empezar.
  var COUNT_KEY = 'iurop:cart-last-count';
  function drawerItemCount() {
    var el = drawer();
    var c = el && el.querySelector('[data-cart-count]');
    var n = c ? parseInt(c.textContent, 10) : NaN;
    return isNaN(n) ? 0 : n;
  }

  function initReserve() {
    if (reserveTimer) {
      window.clearInterval(reserveTimer);
      reserveTimer = null;
    }
    var el = drawer();
    var bar = el && el.querySelector('[data-cart-reserve]');

    // Sin barra = carrito vacío → limpia el inicio para que reinicie al volver.
    if (!bar) {
      try {
        window.localStorage.removeItem(RESERVE_KEY);
        window.localStorage.removeItem(COUNT_KEY);
      } catch (e) {}
      return;
    }

    var count = drawerItemCount();
    try {
      var prev = parseInt(window.localStorage.getItem(COUNT_KEY), 10);
      if (!isNaN(prev) && count > prev) window.localStorage.removeItem(RESERVE_KEY);
      window.localStorage.setItem(COUNT_KEY, String(count));
    } catch (e) { /* localStorage bloqueado: el temporizador sigue funcionando */ }

    var minutes = parseFloat(bar.getAttribute('data-minutes')) || 10;
    var durationMs = minutes * 60 * 1000;
    var countEl = bar.querySelector('[data-reserve-count]');
    var activeEl = bar.querySelector('[data-reserve-active]');
    var expiredEl = bar.querySelector('[data-reserve-expired]');

    var start;
    try {
      start = parseInt(window.localStorage.getItem(RESERVE_KEY), 10);
    } catch (e) {
      start = NaN;
    }
    if (!start || isNaN(start)) {
      start = Date.now();
      try { window.localStorage.setItem(RESERVE_KEY, String(start)); } catch (e) {}
    }

    var tick = function () {
      var remaining = durationMs - (Date.now() - start);
      if (remaining <= 0) {
        if (activeEl) activeEl.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (reserveTimer) {
          window.clearInterval(reserveTimer);
          reserveTimer = null;
        }
        return;
      }
      if (activeEl) activeEl.hidden = false;
      if (expiredEl) expiredEl.hidden = true;
      if (countEl) countEl.textContent = fmt(remaining);
    };

    tick();
    reserveTimer = window.setInterval(tick, 1000);
  }

  // --- Actualización del drawer (Section Rendering) ------------------------
  // En vez de reemplazar TODO el HTML (parpadeo + "desvanecido"), se hace un
  // MORPH quirúrgico sobre el DOM vivo: se tocan solo barra de progreso, líneas
  // y subtotal, así las transiciones CSS animan solas y nada parpadea. Solo se
  // cae al reemplazo completo cuando el carrito cruza vacío <-> con-ítems.
  var pendingQty = {}; // key -> última cantidad deseada (coalescing de clics)

  function parseDrawer(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    return parsed.querySelector('[data-cart-drawer]');
  }

  // Reinicia una animación por clase (quita, fuerza reflow, vuelve a poner).
  function replay(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    el.addEventListener('animationend', function () { el.classList.remove(cls); }, { once: true });
  }
  function pop(el) { replay(el, 'is-pop'); }
  function flash(el) { replay(el, 'is-updated'); }

  // Colapsa y elimina una línea con animación (idempotente).
  function collapseRemove(li) {
    if (!li || li.dataset.leaving) return;
    li.dataset.leaving = '1';
    li.style.height = li.offsetHeight + 'px';
    void li.offsetHeight;
    li.classList.add('is-leaving');
    li.style.height = '0px';
    li.style.opacity = '0';
    li.style.marginTop = '-20px';
    var done = function () { if (li.parentNode) li.parentNode.removeChild(li); };
    li.addEventListener('transitionend', done, { once: true });
    window.setTimeout(done, 420);
  }

  function morphLine(oli, nli) {
    var key = oli.getAttribute('data-line-key');
    // Si hay un cambio optimista pendiente para esta línea, no pises el número
    // (el valor local va por delante del servidor; ya se reconcilia al asentar).
    if (pendingQty[key] == null) {
      var oq = oli.querySelector('.gudslip-cart-drawer__qty-value');
      var nq = nli.querySelector('.gudslip-cart-drawer__qty-value');
      if (oq && nq && oq.textContent.trim() !== nq.textContent.trim()) {
        oq.textContent = nq.textContent;
        pop(oq);
      }
      ['[data-qty-up]', '[data-qty-down]'].forEach(function (sel) {
        var ob = oli.querySelector(sel), nb = nli.querySelector(sel);
        if (ob && nb) ob.setAttribute('data-qty', nb.getAttribute('data-qty'));
      });
    }
    var op = oli.querySelector('.gudslip-cart-drawer__item-prices');
    var np = nli.querySelector('.gudslip-cart-drawer__item-prices');
    if (op && np && op.innerHTML !== np.innerHTML) { op.innerHTML = np.innerHTML; flash(op); }
  }

  function morphItems(live, next) {
    var oldList = live.querySelector('.gudslip-cart-drawer__items');
    var newList = next.querySelector('.gudslip-cart-drawer__items');
    if (!oldList || !newList) return;
    var old = {};
    Array.prototype.forEach.call(oldList.children, function (li) {
      var k = li.getAttribute('data-line-key');
      if (k && !li.dataset.leaving) old[k] = li;
    });
    // QA 2026-08-14 (SC8) "la cajita del pack se ralla / no aparece la cabecera /
    // no cierra bien": antes solo se reconciliaban las filas CON data-line-key, y
    // la cabecera "Pack creado" no tiene clave → no se insertaba ni se borraba
    // nunca. Y las líneas nuevas se añadían AL FINAL, con lo que las del pack
    // dejaban de ser contiguas y los bordes (que se dibujan por fila, cerrando
    // en la última) quedaban sueltos. Ahora se reconstruye la SECUENCIA que
    // manda el servidor, incluidas las filas sin clave.
    var newKeys = {};
    var orden = [];
    Array.prototype.forEach.call(newList.children, function (nli) {
      var k = nli.getAttribute('data-line-key');
      if (!k) {
        // Fila sin clave (cabecera de pack): se toma tal cual del render nuevo.
        orden.push(nli.cloneNode(true));
        return;
      }
      newKeys[k] = true;
      if (old[k]) {
        morphLine(old[k], nli);
        orden.push(old[k]);
      } else {
        // Línea nueva (p. ej. un regalo): entra con fade-in.
        var clone = nli.cloneNode(true);
        clone.classList.add('is-entering');
        orden.push(clone);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { clone.classList.remove('is-entering'); });
        });
      }
    });

    Array.prototype.slice.call(oldList.children).forEach(function (li) {
      if (li.dataset.leaving) return;
      var k = li.getAttribute('data-line-key');
      if (k) {
        if (!newKeys[k]) collapseRemove(li);
      } else {
        li.remove(); // cabecera vieja: la sustituye la del render nuevo
      }
    });

    // Solo se re-ordena si la secuencia CAMBIÓ: así un simple cambio de cantidad
    // no mueve nodos ni corta animaciones en curso.
    var vivas = Array.prototype.slice.call(oldList.children).filter(function (li) {
      return !li.dataset.leaving;
    });
    var igual = vivas.length === orden.length && orden.every(function (el, i) { return vivas[i] === el; });
    if (!igual) orden.forEach(function (el) { oldList.appendChild(el); });
  }

  function morphProgress(live, next) {
    var of = live.querySelector('.gudslip-cd__bar-fill');
    var nf = next.querySelector('.gudslip-cd__bar-fill');
    if (of && nf) of.style.width = nf.style.width || ''; // width transiciona sola
    var oh = live.querySelectorAll('.gudslip-cd__hito');
    var nh = next.querySelectorAll('.gudslip-cd__hito');
    for (var i = 0; i < oh.length && i < nh.length; i++) {
      oh[i].classList.toggle('is-reached', nh[i].classList.contains('is-reached'));
    }
    var ot = live.querySelector('.gudslip-cd__progress-text');
    var nt = next.querySelector('.gudslip-cd__progress-text');
    if (ot && nt && ot.innerHTML !== nt.innerHTML) { ot.innerHTML = nt.innerHTML; flash(ot); }
  }

  function morphSubtotal(live, next) {
    var o = live.querySelector('.gudslip-cd__subtotal-prices');
    var n = next.querySelector('.gudslip-cd__subtotal-prices');
    if (o && n && o.innerHTML !== n.innerHTML) { o.innerHTML = n.innerHTML; flash(o); }
  }

  // Reemplazo completo (solo al cruzar vacío<->con-ítems): crossfade suave.
  function fullSwap(live, next) {
    var oldBody = live.querySelector('.cart-drawer__body');
    var scrollTop = oldBody ? oldBody.scrollTop : 0;
    live.classList.add('is-swapping');
    live.innerHTML = next.innerHTML;
    var newBody = live.querySelector('.cart-drawer__body');
    if (newBody) newBody.scrollTop = scrollTop;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { live.classList.remove('is-swapping'); });
    });
    initReserve();
    syncCurrency();
    syncUpsellArrows();
  }

  function swapFromHTML(html) {
    var live = drawer();
    if (!live) return;
    var next = parseDrawer(html);
    if (!next) return;
    var hadItems = !!live.querySelector('.gudslip-cart-drawer__items');
    var willItems = !!next.querySelector('.gudslip-cart-drawer__items');
    if (hadItems !== willItems) { fullSwap(live, next); return; } // vacío <-> con-ítems
    if (!willItems) return; // ambos vacíos: nada mutable
    // El contador del título NO lo tocan los morphs; si el carrito lo cambió
    // otro actor (la página /cart), refresh() leería el valor VIEJO del drawer
    // y repintaría el header con él. Se sincroniza aquí desde el HTML nuevo.
    var oc = live.querySelector('[data-cart-count]');
    var nc = next.querySelector('[data-cart-count]');
    if (oc && nc) oc.textContent = nc.textContent;
    morphProgress(live, next);
    morphItems(live, next);
    morphSubtotal(live, next);
  }

  // Refresco por GET (para adiciones externas que no devuelven secciones).
  function refresh() {
    var url = window.location.pathname + '?section_id=iurop-cart-drawer';
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (!html) return;
        swapFromHTML(html);
        var countEl = drawer() && drawer().querySelector('[data-cart-count]');
        if (countEl) updateCounts(parseInt(countEl.textContent, 10) || 0);
        // QA 2026-08-14 (SC2): initReserve solo se llamaba desde fullSwap (cruzar
        // vacío<->con ítems), así que al añadir a un carrito que YA tenía cosas
        // el swap es parcial y el temporizador no se re-evaluaba nunca. Aquí se
        // re-evalúa en CADA repintado, que es cuando el nº de unidades cambia.
        initReserve();
        syncCurrency();
      })
      .catch(function () {});
  }

  // --- Protección de envío (plan de carrera 2026-08-17) --------------------
  // El check del pie añade/quita el producto oculto. Candado in-flight para que
  // el doble clic no meta dos; si la petición falla, el check vuelve a su estado.
  function protectionConfig() {
    var el = drawer();
    var sc = el && el.querySelector('[data-protection-config]');
    if (!sc) return null;
    try { return JSON.parse(sc.textContent); } catch (e) { return null; }
  }
  var protBusy = false;
  document.addEventListener('change', function (e) {
    var check = e.target && e.target.closest && e.target.closest('[data-protection-toggle]');
    if (!check || protBusy) return;
    var cfg = protectionConfig();
    if (!cfg || !cfg.variantId) return;
    var wanted = check.checked;
    protBusy = true;
    check.disabled = true;
    var done = function (ok) {
      protBusy = false;
      check.disabled = false;
      if (!ok) check.checked = !wanted;
      else document.dispatchEvent(new CustomEvent('cart:updated', { detail: { noOpen: true } }));
    };
    if (wanted) {
      fetch(cartAddJson(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1, properties: { _proteccion: 'true' } }] })
      }).then(function (r) { done(r.ok); }, function () { done(false); });
    } else {
      fetch(cartJson(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (i) { return i.variant_id === cfg.variantId; })[0];
          if (!line) { done(true); return; }
          var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
          return fetch(changeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (r) { done(r.ok); });
        })
        .catch(function () { done(false); });
    }
  });

  // --- Regalos automáticos por umbral --------------------------------------
  // Clones a 0€ (tag regalo-automatico) que se añaden/quitan solos según el
  // subtotal (sin contar los propios regalos). Config vía [data-gift-config].
  var giftBusy = false;
  function giftConfig() {
    var el = document.querySelector('[data-gift-config]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function reconcileGifts() {
    var cfg = giftConfig();
    // La reconciliación también corre sin regalos configurados: la auto-retirada
    // y el ajuste de cantidad de la protección no pueden depender de cfg.length.
    if ((!cfg.length && !protectionConfig()) || giftBusy) return Promise.resolve(false);
    giftBusy = true;
    return fetch(cartJson(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftIds = cfg.map(function (g) { return g.variantId; });
        // Solo los artículos con envío puntúan para envío gratuito y regalos
        // físicos. La protección sigue puntuando cuando acompaña un envío.
        var protCfg = protectionConfig();
        var protId = protCfg ? protCfg.variantId : 0;
        var qualifying = (cart.items || []).reduce(function (s, i) {
          var isGift = giftIds.indexOf(i.variant_id) !== -1;
          var qualifiesForShipping = i.variant_id === protId || i.requires_shipping !== false;
          return !isGift && qualifiesForShipping ? s + i.final_line_price : s;
        }, 0);
        var toAdd = [];
        var updates = {};
        // Si ya no queda ningún producto FÍSICO (ni regalo ni protección), la
        // protección se retira sola: no tiene sentido proteger un envío digital.
        // (updates DEBE declararse antes de este bloque: la revisión pre-deploy
        // cazó un TypeError silencioso por usarlo antes del var.)
        var realItems = (cart.items || []).filter(function (i) {
          return i.variant_id !== protId && giftIds.indexOf(i.variant_id) === -1 && i.requires_shipping !== false;
        });
        var protLine = (cart.items || []).filter(function (i) { return i.variant_id === protId; })[0];
        if (protLine && realItems.length === 0) updates[String(protId)] = 0;
        // La protección solo tiene sentido a cantidad 1 (dos pestañas a la vez
        // pueden colar un duplicado que el listado oculto no deja ver).
        else if (protLine && protLine.quantity !== 1) updates[String(protId)] = 1;
        var subscriptionItems = (cart.items || []).filter(function (i) {
          return i.requires_shipping !== false && !!(i.selling_plan_allocation || i.selling_plan_id);
        });
        cfg.forEach(function (g) {
          var line = (cart.items || []).filter(function (i) { return i.variant_id === g.variantId; })[0];
          var excludedProductIds = (g.excludedProductIds || []).map(Number);
          var hasEligibleSub = subscriptionItems.some(function (i) {
            return excludedProductIds.indexOf(Number(i.product_id)) === -1;
          });
          // SC7: el umbral del regalo también viene en divisa de TIENDA.
          var qualifies = g.trigger === 'subscription' ? hasEligibleSub : (qualifying >= toPresentment(g.threshold));
          if (qualifies && !line) toAdd.push(g.variantId);
          else if (!qualifies && line) updates[String(g.variantId)] = 0;      // quitar
          else if (qualifies && line && line.quantity !== 1) updates[String(g.variantId)] = 1; // forzar 1
        });
        if (!toAdd.length && !Object.keys(updates).length) return false;
        var chain = Promise.resolve();
        if (Object.keys(updates).length) {
          chain = chain.then(function () {
            return fetch(cartUpdateJson(), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          });
        }
        if (toAdd.length) {
          chain = chain.then(function () {
            return fetch(cartAddJson(), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: toAdd.map(function (id) { return { id: id, quantity: 1, properties: { _regalo: 'true' } }; })
              })
            });
          });
        }
        return chain.then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (changed) { giftBusy = false; return changed; });
  }

  // --- Cambiar cantidad / eliminar línea (change.js + secciones) -----------
  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('data-busy', 'true');

    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
    fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: 'iurop-cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections['iurop-cart-drawer']) {
          swapFromHTML(cart.sections['iurop-cart-drawer']);
        } else {
          return refresh();
        }
        if (cart && typeof cart.item_count === 'number') updateCounts(cart.item_count);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        var d = drawer();
        if (d) d.removeAttribute('data-busy');
        // ¿Quedan clics encadenados (el usuario siguió pulsando)? Envía el
        // último y aplaza los regalos hasta que se asiente el valor final.
        if (Object.keys(pendingQty).length) {
          flushPending();
        } else {
          // Si el cambio cruza un umbral (p.ej. quitar un item baja de 95€),
          // reconcilia los regalos y re-pinta.
          reconcileGifts().then(function (ch) { if (ch) refresh(); });
        }
      });
  }

  // Coalescing de cambios de cantidad: se guarda la última cantidad deseada por
  // línea y se envía una sola petición cuando el fetch en curso queda libre.
  function flushPending() {
    if (busy) return;
    var keys = Object.keys(pendingQty);
    if (!keys.length) return;
    var key = keys[0];
    var q = pendingQty[key];
    delete pendingQty[key];
    changeLine(key, q);
  }
  function queueChange(key, q) {
    pendingQty[key] = q;
    flushPending();
  }
  function currentQty(li, key) {
    if (pendingQty[key] != null) return pendingQty[key];
    var v = li && li.querySelector('.gudslip-cart-drawer__qty-value');
    return (v && parseInt(v.textContent, 10)) || 0;
  }
  // +/- con actualización OPTIMISTA: el número cambia al instante (con pop) y el
  // servidor confirma después; el morph reconcilia precio/subtotal/barra.
  function bumpQty(btn, delta) {
    var key = btn.getAttribute('data-key');
    var li = btn.closest('.gudslip-cart-drawer__item');
    var q = currentQty(li, key) + delta;
    if (q <= 0) {
      if (li) collapseRemove(li); // baja a 0 = quitar, en el acto
      queueChange(key, 0);
      return;
    }
    var v = li && li.querySelector('.gudslip-cart-drawer__qty-value');
    if (v) { v.textContent = q; pop(v); }
    if (li) {
      var u = li.querySelector('[data-qty-up]'), d = li.querySelector('[data-qty-down]');
      if (u) u.setAttribute('data-qty', q);
      if (d) d.setAttribute('data-qty', q);
    }
    queueChange(key, q);
  }

  // --- Modal Klarna --------------------------------------------------------
  function klarnaModal() {
    var el = drawer();
    return el && el.querySelector('[data-cart-klarna]');
  }
  function openKlarna() {
    var m = klarnaModal();
    if (m) m.hidden = false;
  }
  function closeKlarna() {
    var m = klarnaModal();
    if (m) m.hidden = true;
  }

  // --- Delegación de eventos ----------------------------------------------
  document.addEventListener('click', function (e) {
    // #33: desplegar/plegar el "Pack creado".
    var packToggle = e.target.closest('[data-pack-toggle]');
    if (packToggle) {
      var pid = packToggle.getAttribute('data-pack-toggle');
      var collapsed = packToggle.classList.toggle('is-collapsed');
      packToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      var items = document.querySelectorAll('[data-pack-id="' + pid + '"]');
      Array.prototype.forEach.call(items, function (it) {
        it.classList.toggle('is-collapsed', collapsed);
      });
      return;
    }

    var up = e.target.closest('[data-qty-up]');
    if (up) {
      e.preventDefault();
      bumpQty(up, 1);
      return;
    }

    var down = e.target.closest('[data-qty-down]');
    if (down) {
      e.preventDefault();
      bumpQty(down, -1);
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      var rli = remove.closest('.gudslip-cart-drawer__item');
      if (rli) collapseRemove(rli); // desaparece ya, sin esperar al servidor
      queueChange(remove.getAttribute('data-key'), 0);
      return;
    }

    if (e.target.closest('[data-cart-klarna-open]')) {
      e.preventDefault();
      openKlarna();
      return;
    }
    if (e.target.closest('[data-cart-klarna-close]')) {
      e.preventDefault();
      closeKlarna();
      return;
    }
  });

  // --- Código de descuento ---------------------------------------------------
  // Guarda el código en la cookie de descuento de Shopify (GET /discount/CODE);
  // se aplica automáticamente en el checkout. Mensajes por data-msg del form.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('input[name="discount"]');
    var msg = form.parentElement.querySelector('[data-discount-msg]');
    var code = input && input.value.trim();
    if (!code) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'discount/' + encodeURIComponent(code), { method: 'GET' })
      .then(function (res) {
        if (!msg) return;
        msg.hidden = false;
        if (res.ok || res.redirected) {
          msg.textContent = msg.getAttribute('data-msg-ok') || '';
          msg.classList.remove('is-error');
        } else {
          msg.textContent = msg.getAttribute('data-msg-error') || '';
          msg.classList.add('is-error');
        }
      })
      .catch(function () {
        if (!msg) return;
        msg.hidden = false;
        msg.textContent = msg.getAttribute('data-msg-error') || '';
        msg.classList.add('is-error');
      });
  });

  // Esc: cierra primero el modal Klarna (captura → corta el cierre del drawer
  // que hace global.js en fase de burbuja).
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var m = klarnaModal();
      if (m && !m.hidden) {
        closeKlarna();
        e.stopPropagation();
      }
    },
    true
  );

  // Flechas del carrusel de upsell (escritorio). Delegadas en document porque
  // el track se re-pinta con cada refresco del drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (!btn) return;
    var vp = btn.closest('.gudslip-cd__upsell-viewport');
    var track = vp && vp.querySelector('[data-upsell-track]');
    if (!track) return;
    var card = track.querySelector('.gudslip-cd__upsell-card');
    // Un paso = una card + su gap; si no hay card, media ventana.
    var step = card ? card.offsetWidth + 12 : Math.round(track.clientWidth / 2);
    var dir = btn.hasAttribute('data-upsell-prev') ? -1 : 1;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  // Oculta la flecha que no lleva a ninguna parte (en los topes del recorrido).
  function syncUpsellArrows() {
    document.querySelectorAll('.gudslip-cd__upsell-viewport').forEach(function (vp) {
      var track = vp.querySelector('[data-upsell-track]');
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth;
      vp.classList.toggle('has-scroll', max > 1);
      var prev = vp.querySelector('[data-upsell-prev]');
      var next = vp.querySelector('[data-upsell-next]');
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    });
  }

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-upsell-track')) syncUpsellArrows();
  }, true);
  window.addEventListener('resize', syncUpsellArrows);

  // Rueda del ratón sobre el carrusel de "Te puede interesar": un ratón solo
  // genera deltaY, y como el track scrollea en HORIZONTAL el gesto se perdía
  // (con trackpad sí iba, porque genera deltaX). Traducimos vertical→horizontal.
  // Delegado en document: el track se re-pinta con cada refresco del drawer.
  document.addEventListener('wheel', function (e) {
    var track = e.target.closest && e.target.closest('.gudslip-cd__upsell-track');
    if (!track) return;
    // Gesto ya horizontal (trackpad): que lo maneje el navegador.
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 1) return;
    // En los topes NO capturamos: así la rueda sigue haciendo scroll del panel.
    if ((e.deltaY < 0 && track.scrollLeft <= 0) || (e.deltaY > 0 && track.scrollLeft >= max - 1)) return;
    e.preventDefault();
    track.scrollLeft += e.deltaY;
  }, { passive: false });

  // Adición externa → refresca el contenido. Por defecto abre el drawer; con
  // detail.noOpen (p. ej. el modal quick-view / hero) solo refresca en silencio
  // para no tapar el modal con el sidecart.
  document.addEventListener('cart:updated', function (e) {
    // Primero reconcilia regalos (añade el que corresponda al nuevo total),
    // luego re-pinta el drawer ya con el regalo dentro.
    reconcileGifts().then(function () {
      if (e && e.detail && e.detail.noOpen) {
        refresh();
      } else {
        refresh().then(openDrawer);
      }
    });
  });

  // Init
  function bootDrawer() {
    initReserve();
    syncCurrency();
    syncUpsellArrows();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDrawer);
  } else {
    bootDrawer();
  }
  // Reconcilia al cargar (carritos previos que ya superan el umbral sin regalo,
  // o regalos que quedaron por debajo). Silencioso; si cambia algo, re-pinta.
  reconcileGifts().then(function (ch) { if (ch) refresh(); });
})();
